import React from "react";
import Modal from "./modal";
import { useTranslation } from "react-i18next";
import { FiArrowRight, FiTrash2 } from "react-icons/fi";

function normalizeStatusTitle(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function getAgeInDays(dateString) {
  if (!dateString) {
    return null;
  }

  const birthDate = new Date(dateString);

  if (Number.isNaN(birthDate.getTime())) {
    return null;
  }

  return Math.floor((Date.now() - birthDate.getTime()) / (1000 * 60 * 60 * 24));
}

const statusColorMap = {
  "Oestrus":    "#f1c40f",
  "Saillie":    "#f1c40f",
  "Diagnostic": "#3498db",
  "Gestation":  "#0746f3f0",
  "Repos":      "#27ae60",
  "Vêlage":     "#ff2911",
  "Avortement":  "#000",
  "Supprimer événement": "#d32f2f",
};

const maleHiddenOptions = new Set(["Oestrus", "Saillie", "Diagnostic"]);

export default function StatusChoiceModal({ show, currentStatus, animalGender, animalBirthDate, onSelect, onClose }) {
  const { t } = useTranslation();
  const ageInDays = getAgeInDays(animalBirthDate);
  const normalizedStatus = normalizeStatusTitle(currentStatus);

  function getOptions() {
    if (animalGender === "male") {
      return [];
    }

    if (normalizedStatus === "croissance") {
      if (ageInDays === null || ageInDays < 365) {
        return [];
      }

      return ["Oestrus", "Saillie"];
    }

    switch (currentStatus) {
      case "Vêlage":
        return ["Oestrus", "Saillie", "Supprimer événement"];
      case "Oestrus":
        return ["Saillie", "Supprimer événement"];
      case "Saillie":
        return ["Diagnostic", "Supprimer événement"];
      case "Gestation":
        return ["Repos", "Vêlage", "Avortement", "Supprimer événement"];
      case "Repos":
        return ["Vêlage", "Avortement", "Supprimer événement"];
      case "Avortement":
        return ["Saillie", "Oestrus", "Supprimer événement"];
      default:
        return ["Oestrus", "Saillie"];
    }
  }

  const options = getOptions().filter((option) => !(animalGender === "male" && maleHiddenOptions.has(option)));

  return (
    <Modal show={show} onClose={onClose}>
      <div className="rp-detail-modal">
        <h2 className="rp-modal-title">
          <FiArrowRight /> {t("reproWheel.chooseNextStep") || "Choose next step"}
        </h2>
        {options.length > 0 && (
          <div className="rp-choice-grid">
            {options.map((op, i) => {
              const isDelete = op === "Supprimer événement";
              const color = statusColorMap[op] || "#2a7d40";
              return (
                <button
                  key={i}
                  className={`rp-choice-btn ${isDelete ? 'rp-choice-danger' : ''}`}
                  style={!isDelete ? { borderLeft: `4px solid ${color}` } : {}}
                  onClick={() => onSelect(op)}
                >
                  {isDelete ? <FiTrash2 /> : <span className="rp-choice-dot" style={{ backgroundColor: color }}></span>}
                  <span>{t(`reproWheel.statusLabels.${op}`) || op}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </Modal>
  );
}
